/**
 * Where to go after sign-in: a path on this site, or a page on one of the hosts the server allows (the
 * memory explorer, which sends people here with ?next=). Anything else goes home — ?next= must never be
 * a way to send someone to an arbitrary site.
 */
export function safeNext(raw: string | null, returnHosts: string[]): string {
  const n = raw ?? "/";
  // No control characters or backslashes: browsers drop tabs and newlines ("/\t/evil.example" → "//evil.example").
  if (/^\/(?![/\\])[^\x00-\x1f\x7f\\]*$/.test(n)) return n;
  if (n.startsWith("/")) return "/";
  try {
    const u = new URL(n);
    return u.protocol === "https:" && returnHosts.includes(u.host) ? u.toString() : "/";
  } catch {
    return "/";
  }
}
